export const REGEX = {
    WHITESPACE_GLOBAL: /\s/g,        // every single whitespace
    MULTIPLE_WHITESPACE: /\s+/g,     // 1+ continuous whitespace
    WHITESPACE: /\s+/,
    ANYTHING_NONEMPTY: /.+/,
    NON_BREAKING_SPACE: /(&nbsp;|\u00A0)/g,
    LEADING_WHITESPACE_MULTILINE: /^\s+/gm,
    ZERO_WIDTH_SPACE: /\u200B/g,
    SINGLE_QUOTE_GLOBAL: /'/g,
    SPACE_GLOBAL: / /g,
    REMOVE_DOLLAR_AND_COMMA: /[$,]/g,
    TEXT_INSIDE_PARENTHESES: /\((.*?)\)/g,
    QUARTER_YEAR: /^([1-4]Q\d{4}|Q[1-4]\d{4})$/,
    QUARTER_YEAR_LEADING: /([1-4])Q\d{4}/,
    QUARTER_YEAR_TRAILING: /Q([1-4])\d{4}/,
    QUARTER_ONLY: /Q([1-4])/,
    DOUBLE_QUOTE_GLOBAL: /"/g,
    REMOVE_QUOTE_COMMA_NEWLINE: /[",\n]/,
    REMOVE_HYPHEN: /-/g,
    EXCEL_RANGE: /(.*?)!\$?([A-Z]+)\$?(\d+):\$?([A-Z]+)\$?(\d+)/,
    STRIP_BOUNDARY_DOUBLE_QUOTES: /^"|"$/g,
    WORD_WITH_APOSTROPHE_AND_HYPHEN: /\b[\w'-]+\b/g,
    NON_DIGIT_GLOBAL: /\D/g,
    STRIP_ALL_QUOTES: /['"]+/g,
    LAST_PARENTHESES_AT_END: /\((.*)\)[^()]*$/,
    DATE_YYYY_MM_DD: /^\d{4}-\d{2}-\d{2}$/,
    VALID_QUARTERLY_RESULT_FILE: /^[^_]+_(\d{4}-Q[1-4])_Quarterly_Results\.(xlsm|xlsx)$/,
    ROMAN_NUMERALS_ONLY: /^[IVXLCDM]+$/,
    END_NEWLINE: /\n$/,
    PROVED_RESERVES_ENDING: /\s*\(Proved Reserves\)$/,
    FILE_EXTENSION_REGEX: /\.\w{2,5}$/,
    STARTS_WITH_SLASH: /^\//,
    YEAR_QUARTER: /^(\d{4})-Q(\d)$/,
    YEAR_QUARTER_Q: /^(\d{4})-Q([1-4])$/,
    EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    EMAIL_PATTERN: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
    STARTS_WITH_HTTP: /^https?:\/\//,
    STARTS_WITH_WWW: /^www\./,
    STARTS_WITH_FUND: /^fund\s+/i,
    LEADING_ALPHABETS: /^[A-Za-z]+/,
    ROMAN_AFTER_SPACE_OR_HYPHEN: /(?:\s|-)([IVXLCDM]+)\b/,
    NUMBER_IN_PARENTHESES: /\(\s*(\d+)\s*\)/,
    ROMAN_HYPHEN_WORD_END: /\b[IVXLCDM]+\-(\w+)\b$/,
    NUMBER_IN_PARENTHESES2: /\(\d+\)/,
    PREFIX_ROMAN_PATTERN: /^[^\s]+[\s-]+[IVXLCDM]+[\s-]*/,
    BLOB_URL: /blob:http[s]?:\/\/[^"]+/,
    ISO_DATE: /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(?:\.\d+)?([+-]\d{2}:\d{2}|Z)?)?$/,
    MODEL_XLSX_FILE: /\/blobServices\/default\/containers\/quilt\/blobs\/.+\/Review\/.+Model.+xlsx/,
    QUARTERLY_REVIEW_FILE: /\/blobServices\/default\/containers\/quilt\/blobs\/.+\/Review\/.+\/[A-Z]+_(?:\d{4}[-_]Q[1-4]|Q[1-4][-_]\d{4})_Quarterly_Results\.(xlsm|xlsx)$/,
    LOWERCASE_START: /^[a-z]+/,
    ROMAN_NUMERAL_ROUND_BRACKET: /([ivxlcdm]+)$/i,
    ROMAN_NUMERAL: /^[ivxlcdm]+$/i,
    REMOVE_BG_COLOR: /background-color\s*:\s*[^;]+;?/gi,
    REMOVE_COLOR: /color\s*:\s*[^;]+;?/gi,
    BR_TAG: /<br\s*\/?>/gi,
    MULTIPLE_BR: /(<br\s*\/?>\s*){2,}/gi,
    EMPTY_PARAGRAPHS: /(<p>\s*(<br\s*\/?>)*\s*<\/p>)+/gi,
    LI_WITH_STRONG: /<li(?:\s+[^>]*)?>\s*<strong>/gi,
    LI_OPENING_TAG: /<li[^>]*>/gi
};